import React, { useEffect } from 'react';
import Navbar from './components/navbar';
import HomeContent from './components/homeContent'
import About from './components/about';
import Feature from './components/feature';
import ScreenShot from './components/screenshot';
import Blog from './components/blog';
import Price from './components/price';
/* import Testimonial from './components/testimonial'; */
import Contact from './components/contact';
import Subscribe from './components/subscribe';
import Footer from './components/footer';

const HomeOne = () => {

	document.body.classList.remove('landing-page');
	document.body.classList.remove('home-style');
	document.body.classList.remove('three');
	document.body.classList.remove('home-style-two');

	useEffect(() => {

		if (document.querySelector('.tap-top') !== null) {
			// scroll to top
			document.querySelector('.tap-top').addEventListener('click', () => {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			})

			// scroll event listener
			document.addEventListener('scroll', () => {
				if (document.querySelector('.tap-top') !== null) {
					if (window.scrollY > 500) {
						document.querySelector('.tap-top').classList.add('show')
					} else {
						document.querySelector('.tap-top').classList.remove('show')
					}
				}

			})
		}

	}, [])

	return (
		<div>
			{/* Navbar Component*/}
			<Navbar />

			{/* Home content*/}
			<HomeContent />

			{/* About Component*/}
			<About />

			{/*Feature Component*/}
			<Feature />

			{/*ScreenShot Component*/}
			<ScreenShot />

			{/*Blog Component*/}
			<Blog />

			{/*Price Component*/}
			<Price />

			{/*Testimonial Component*/}
			{/* <Testimonial /> */}

			{/*Contact Component*/}
			<Contact />

			{/*Subscription Component*/}
			<Subscribe />

			{/*Footer Component*/}
			<Footer />
		</div>
	);
}

export default HomeOne;


// WEBPACK FOOTER //
// ./src/home-one.js